import { setColor, setWebsiteType } from '@/store/onLoadData/onLoadDataSlice';
import { environments, eWebsiteColors, eWebsiteTypes, getCurrentEnvironment } from '@/utils';
import { useDispatch, useSelector } from 'react-redux';

export const EnvironmentBadge = () => {
	const env = import.meta.env.VITE_ENV || getCurrentEnvironment();
	const dispatch = useDispatch();

	const currentType = useSelector(state => state.onLoadData.websiteType);

	if (!env || env === environments.PRODUCTION) return null;

	const canShowUI = env === environments.DEVELOPMENT || env === environments.STAGING;

	if (!canShowUI) return null;

	const label = `${env.toUpperCase()} Environment`;

	const handleToggle = () => {
		const toggleAllowed = env === environments.DEVELOPMENT || env === environments.STAGING;

		if (!toggleAllowed) return;

		if (currentType === eWebsiteTypes.KUICK) {
			dispatch(setWebsiteType(eWebsiteTypes.DINEORDER));
			dispatch(setColor(eWebsiteColors.DINEORDER));
		} else {
			dispatch(setWebsiteType(eWebsiteTypes.KUICK));
			dispatch(setColor(eWebsiteColors.KUICK));
		}
	};

	return (
		<>
			<div
				className="
          hidden md:inline-flex items-center ml-3 gap-2
          rounded-full pl-2 pr-2 py-0.5
          bg-slate-900/40  
          border border-slate-600/30
          text-slate-100 text-[10px] font-medium tracking-wide
          backdrop-blur-sm shadow-sm
          max-w-xs
        "
			>
				<div className="inline-flex items-center truncate">
					<span className="relative flex h-2 w-2 mr-1.5">
						<span className="absolute inline-flex h-full w-full rounded-full bg-green-300/40 animate-ping" />
						<span className="relative inline-flex h-2 w-2 rounded-full bg-green-300/80" />
					</span>
					<span className="truncate">{label}</span>
				</div>

				<div className="w-px h-3 bg-slate-600/40" />

				<button
					onClick={handleToggle}
					className="
            px-2 py-0.5 rounded-md text-[10px] font-semibold
            bg-slate-700 hover:bg-slate-600
            border border-slate-500/40 transition-all cursor-pointer
            whitespace-nowrap
          "
				>
					{currentType === eWebsiteTypes.KUICK ? 'Switch to Dine' : 'Switch to Kuick'}
				</button>
			</div>

			<div className="md:hidden fixed bottom-16 right-3 z-[60] select-none">
				<div
					className="
            inline-flex items-center gap-2 rounded-full
            px-2.5 py-1
            bg-slate-900/55  
            border border-slate-600/40
            text-slate-100 text-[10px] font-medium tracking-wide
            backdrop-blur-md shadow-lg
            max-w-[80vw] truncate
          "
				>
					<span className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse opacity-80" />
					<span className="truncate">{label}</span>
				</div>
			</div>
		</>
	);
};
